import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  loadWhisperCore: false,
  type: 'application',
  auth: 'none',
  logFetchErrors: {
    options: {
      ignoreErrors: []
    }
  },
  htmlTitle: 'Customer Portal Application',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/customer-portal-app'
});